import { iClientSettlement } from "./ClientSettlement";
import { iClientViolation } from "./ClientViolation";

export interface iClientPaymentRes {
    success?: boolean;
    code?: number;
    client_payment_method?: iClientPaymentMethod;
    client_payments: iClientPayment;
    client_payment_transactions: iClientPaymentTransactions[];
    client_fees: iClientFees[];
    client_fee_transactions: iClientFeeTransactions[];
    client_re_transactions: iClientReTransactions[];
    client_overall?: { real_estate_agent?: string };
    last_action?: string;
}

export interface iClientPaymentsGroupedRes {
    success?: boolean;
    code?: number;
    programs?: iClientPaymentsProgramGroup[];
    last_action?: string;
}

export interface iClientPaymentsProgramGroup {
    program?: {
        id?: string;
        name?: string;
        status?: string;
    };
    client_payments?: iClientPayment;
    client_payment_transactions?: iClientPaymentTransactions[];
    client_fees?: iClientFees[];
    client_fee_transactions?: iClientFeeTransactions[];
    client_re_transactions?: iClientReTransactions[];
    client_overall?: { real_estate_agent?: string };
}

export interface iClientPaymentMethodRes {
    success?: boolean;
    code?: number;
    client_payment_method?: iClientPaymentMethod;
    chart_amount: {
        programs: string[];
        amounts: number[];
    };
    chart_balance: {
        total: number;
        paid: number;
    };
    last_action?: string;
}

export interface iClientPayment {
    id?: String;
    start_date?: string;
    total_amount?: number;
    total_balance?: number;
    estimated_deposit?: number;
    paid_in_full_date?: string;
    program_id?: string;
    program: {
        id: string;
        name: string;
        status: string;
        contract_open: string;
        projected_contract_close?: string;
        contract_closed?: string;
        info?: string;
    };
    rowId?: string; // Added for reactformhooks usefieldarray
    total_balance_fees?: number;
    total_amount_fees?: number;
    preferred_payment_method?: string;
    payment_method_id?: string;
    payment_interval?: number;
    number_of_payments?: number;
    recurrent_amount?: number;
    next_payment_date?: string;
    status?: string;
    type?: string;
}

export interface iClientPaymentMethod {
    id?: String;
    routing_number?: string;
    account_number?: string;
    cc?: string;
    code?: string;
    cc_ex?: string;
    bank?: string;
    xp_system?: string;
}

export interface iClientPaymentTransactions {
    id?: string;
    date: string;
    amount?: number;
    notes?: string;
    receipt_made_by?: string;
    receipt_number?: string;
    refund?: string;
    charge_back?: string;
    return?: string;
    reference?: string;
    payment_type?: string;
    preferred_payment_method?: string;
    payment_method_id?: string;
    name?: optionProps;
    program_id?: string;
    user?: { name?: string };
    nf?: boolean;
    transaction_type?: string;
    send_receipt?: boolean;
    rowId?: string; // Added for reactformhooks usefieldarray
    created_at?: Date;
}
export interface iClientFees {
    id?: string;
    fee_reference?: string;
    fee_type?: string;
    total_amount?: number;
    balance?: number;
    violation_id?: string;
    settlement_id?: string;
    fee_negotiator?: string;
    program_id?: string;
    locked?: boolean; // Added for locking the fee
    rowId?: string; // Added for reactformhooks usefieldarray
}

export interface iClientFeeTransactions {
    id?: string;
    date: string;
    status?: string;
    receipt_number?: string;
    reference?: string;
    amount?: number;
    notes?: string;
    payment_type?: string;
    receipt_made_by?: string;
    fee_id?: string;
    user?: { name?: string };
    name?: optionProps;
    nf?: boolean;
    rowId?: string; // Added for reactformhooks usefieldarray
}

export interface iClientReTransactions {
    id?: string;
    closing_date?: string;
    payment_date?: string;
    property_address?: string;
    transaction_type?: string;
    total_commission?: number;
    split?: number;
    broker_fee?: number;
    notes?: string;
    program_id?: string;
    real_estate_commissions?: { status?: string }[];
    rowId?: string; // Added for reactformhooks usefieldarray
}

export interface iClientFeeReferencesRes {
    success?: boolean;
    code?: number;
    violations: iClientViolation[];
    settlements: iClientSettlement[];
}

export interface optionProps {
    label: string;
    value: string;
}

export interface ClientPaymentTransactionRow {
    id?: string;
    date?: string;
    amount?: number;
    notes?: string;
    receipt_made_by?: string;
    receipt_number?: string;
    refund?: number;
    charge_back?: number;
    return?: number;
    reference?: string;
    payment_type?: string;
    transaction_type?: string;
    name?: string;
    rowId?: string;
}

export interface iClientFeesWithTransactions {
    id?: string;
    fee_reference?: string;
    fee_type?: string;
    total_amount?: number;
    balance?: number;
    violation_id?: string;
    settlement_id?: string;
    fee_negotiator?: string;
    program_id?: string;
    locked?: boolean; // Added for locking the fee
    rowId?: string; // Added for reactformhooks usefieldarray
    client_fee_transactions: iClientFeeTransactions[];
}

export interface PaymentMethodOption {
    id: string;
    value: string;
}

export interface PaymentMethodOptionRes {
    success?: boolean;
    code?: number;
    options: PaymentMethodOption[];
}

export interface PaymentMethodsRes {
    success?: boolean;
    code?: number;
    payment_methods: PaymentMethod[];
}

export interface PaymentMethod {
    id: string;
    personId: string;
    creditCard: CreditCard | null;
    bankAccount: BankAccount | null;
    xpInformation: XPInformation | null;
}

export interface CreditCard {
    cardHolderName: string;
    creditCardNumber: string;
    expirationDate: string;
    ccv: string;
    type: string | null;
}

export interface BankAccount {
    bankName: string;
    accountNumber: string;
    routingNumber: string;
}

export interface XPInformation {
    xpSystem: string;
}

export enum PaymentMethodType {
    CreditCard = "Credit Card",
    BankAccount = "Bank Account",
    XPInformation = "XP information",
}
